var render, staticRenderFns
import script from "./BitrixAuditForm.vue?vue&type=script&lang=js&"
export * from "./BitrixAuditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e339e9a",
  null
  
)

export default component.exports